import { usePoll } from "@inertiajs/react";
import { useEffect } from "react";

/**
 * Auto-refreshes the page while status === "processing".
 *
 * @param status The resource status string (e.g. "processing").
 */
export function useAutoRefreshOnProcessing(status: string) {
  const { start, stop } = usePoll(5000, {}, { autoStart: false });

  useEffect(() => {
    if (status === "processing") {
      start();
    } else {
      stop();
    }
    return () => stop();
  }, [status, start, stop]);
}
